import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

function RequiredAsterisk({
    required,
    classes: { requiredAsterisk },
}) {
    return required && (
        <React.Fragment>
            {' '}
            <Typography color='error' component='span' className={requiredAsterisk}>*</Typography>
        </React.Fragment>
    );
}

RequiredAsterisk.propTypes = {
    required: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        requiredAsterisk: PropTypes.string,
    }).isRequired,
};

export default React.memo(RequiredAsterisk);
